import React from 'react';

class FieldNoteForDevelopers extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      label: props.label,
      placeholder: props.placeholder,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    return { label: nextProps.label, placeholder: nextProps.placeholder };
  }

  render() {
    if (!this.state.label && !this.state.placeholder) {
      return <></>;
    }
    return <div className="card">
      <div className="card-header">
        Note for developers
      </div>
      <div className="card-body">
        You can update this field programmatically by using the following Javascript code:<br />
        <code style={{ fontSize: '0.8em' }}>
          window.acerillCustomFormsEventBus.publish(&#123;eventType: &apos;UPDATE_VALUE_COMMAND&apos;, fieldPredicate: &#123; {this.state.label ? `label: '${this.state.label}'` : `placeholder: '${this.state.placeholder}'`} &#125;, value: &apos;some value&apos;&#125;);
        </code>
      </div>
    </div>;
  }

}
export default FieldNoteForDevelopers;
